import React from 'react';
import Typography from '@nubank/nuds-web/components/Typography/Typography';
import Box from '@nubank/nuds-web/components/Box/Box';

import { StyledImage } from '../styles/StyledImage';

function SectionDifferent() {
  return (
    <Box
      tag="section"
      display={{ md: 'flex' }}
      alignItems={{ md: 'center' }}
      paddingVertical={{ xs: '3x', md: '20x', lg: '12x' }}
      paddingHorizontal={{ xs: '3x', md: '12x', lg: 195 }}
    >
      <Box
        flex={{ md: '1 0 0' }}
      >
        <StyledImage
          loading="lazy"
          srcSet={{
            xs: 'nubank-indoor-pool/nubank-indoor-pool@xs-2x.jpg',
            md: 'nubank-indoor-pool/nubank-indoor-pool@md-2x.jpg',
            lg: 'nubank-indoor-pool/nubank-indoor-pool@lg-2x.jpg',
          }}
          altIntlKey="ABOUT_US.DIFFERENT.IMAGE_ALT"
        />
      </Box>
      <Box
        flex={{ md: '1 0 0' }}
        paddingVertical={{ xs: '16x', md: '0x' }}
        paddingHorizontal={{ xs: '3x', md: '16x' }}
      >
        <Typography
          variant="title"
          color="black"
          colorVariant="default"
          gutterBottom={2}
          intlKey="ABOUT_US.DIFFERENT.TITLE"
        />
        <Typography
          variant="paragraph2"
          color="black"
          colorVariant="default"
          gutterBottom={2}
          maxWidth={{ lg: '24rem' }}
          intlKey="ABOUT_US.DIFFERENT.WE_ARE"
        />
        <Typography
          variant="paragraph2"
          color="black"
          colorVariant="default"
          gutterBottom={2}
          maxWidth={{ lg: '24rem' }}
          intlKey="ABOUT_US.DIFFERENT.WE_ARE_NUS"
        />
        <Typography
          variant="paragraph2"
          color="black"
          colorVariant="default"
          gutterBottom={2}
          maxWidth={{ lg: '24rem' }}
          intlKey="ABOUT_US.DIFFERENT.NO_BUROCRACY"
        />
        <Typography
          variant="paragraph2"
          color="black"
          colorVariant="default"
          maxWidth={{ lg: '24rem' }}
          intlKey="ABOUT_US.DIFFERENT.YOUR_OPNION"
        />
      </Box>
    </Box>
  );
}

export default React.memo(SectionDifferent);
